import { Injectable, inject } from '@angular/core';
import { Validators } from '@angular/forms';
import {
  GetRowsRequest,
  RestApiService,
} from '@core/services/rest-api.service';
import { dvNumberMaskPresets } from '@devinco/ui/dds';
import {
  DvCheckboxElement,
  DvDatePickerLegacyElement,
  DvDropdownClientSideElement,
  DvDynamicFormElement,
  DvNumberboxElement,
  DvTextboxElement,
} from '@devinco/ui/legacy';
import { Entity } from '@shared/constants/entity';

@Injectable()
export class VehicleLeasingTabService {
  private readonly restApi = inject(RestApiService);

  financingElements: DvDynamicFormElement[] = [
    new DvTextboxElement({
      colspan: 6,
      key: 'FinancingCompany',
      label: 'VehicleLeasingTab.FinancingCompany',
    }),
    new DvDropdownClientSideElement({
      colspan: 6,
      key: 'FinancingTypeID',
      label: 'VehicleLeasingTab.Type',
      labelKeys: ['Name'],
      valueKey: 'FinancingTypeID',
      ready: params => {
        const request: GetRowsRequest = {
          entity: Entity.FinancingType,
          fields: ['FinancingTypeID', 'Name'],
        };
        this.restApi.setDropdownData(request, params);
      },
    }),
    new DvDatePickerLegacyElement({
      colspan: 6,
      key: 'FinancingPeriodStart',
      label: 'VehicleLeasingTab.StartDate',
    }),
    new DvNumberboxElement({
      colspan: 6,
      key: 'FinancingPeriodMonths',
      label: 'VehicleLeasingTab.FinancingPeriod',
      validators: [Validators.min(1)],
    }),
    new DvNumberboxElement({
      colspan: 6,
      key: 'FinancingAllowedKm',
      label: 'VehicleLeasingTab.MaximumKm',
      validators: [Validators.min(1)],
    }),
    new DvTextboxElement({
      colspan: 6,
      key: 'FinancingAgreementNumber',
      label: 'VehicleLeasingTab.FinancingAgreementNumber',
    }),
  ];

  statusElements: DvDynamicFormElement[] = [
    new DvTextboxElement({
      colspan: 4,
      key: 'FinancingMileageAtStart',
      label: 'VehicleLeasingTab.MileageAtStartDate',
      readonly: true,
      disabled: true,
    }),
    new DvTextboxElement({
      colspan: 4,
      key: 'Mileage',
      label: 'VehicleLeasingTab.CurrentMileage',
      readonly: true,
      disabled: true,
    }),
    new DvDatePickerLegacyElement({
      colspan: 4,
      key: 'FinancingPeriodEnd',
      label: 'VehicleLeasingTab.EndDateFinancingPeriod',
      readonly: true,
      disabled: true,
    }),
    new DvTextboxElement({
      colspan: 4,
      key: 'FinancingRemainingMonths',
      label: 'VehicleLeasingTab.RemainingMonths',
      readonly: true,
      disabled: true,
    }),
    new DvTextboxElement({
      colspan: 4,
      key: 'FinancingRemainingKm',
      label: 'VehicleLeasingTab.RemainingKm',
      readonly: true,
      disabled: true,
    }),
    new DvTextboxElement({
      colspan: 4,
      key: 'FinancingRemainingKmMonth',
      label: 'VehicleLeasingTab.RemainingKmMonth',
      readonly: true,
      disabled: true,
    }),
    new DvTextboxElement({
      colspan: 4,
      key: 'FinancingPeriodChart',
      hidden: true,
      readonly: true,
      disabled: true,
    }),
    new DvNumberboxElement({
      colspan: 4,
      key: 'FinancingIdealKmDeviation',
      label: 'Vehicle.FinancingIdealKmDeviation',
      fieldMask: dvNumberMaskPresets.NegativeFormattedNumber,
      disabled: true,
    }),
    new DvCheckboxElement({
      key: 'ShowRecord',
      hidden: true,
    }),
    new DvTextboxElement({ key: 'Username', hidden: true }),
    new DvTextboxElement({ key: 'VehicleTypeDescription', hidden: true }),
  ];
}
